import React from "react";
import { FileTextIcon, ClipboardCheckIcon, FilterIcon, Grid3x3Icon, SearchIcon, FolderOpenIcon, BoxIcon } from "lucide-react";
import { tools } from "../../data/content";
import { SectionCta } from "../SectionCta";
const iconMap: Record<string, BoxIcon> = {
  file: FileTextIcon,
  check: ClipboardCheckIcon,
  filter: FilterIcon,
  grid: Grid3x3Icon,
  search: SearchIcon,
  folder: FolderOpenIcon
};
export function Tools() {
  return <section className="w-full bg-canvas px-4 py-16 sm:py-20" data-id="element-293" data-mp="28kxti2htihc3">
      <div className="mx-auto max-w-4xl" data-id="element-294" data-mp="23s4ttt17hz6v">
        <h2 className="text-center font-serif text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-295" data-mp="23rbqz35dbtu0">
          And you'll <em className="text-brand" data-id="element-296" data-mp="1yrgxqsy4es5s">also receive</em>
        </h2>
        <p className="mt-3 text-center text-[17px] text-muted" data-id="element-297" data-mp="1tvrvuiymoz6b">Professional tools to use on every case you review.</p>

        <ul className="mt-10 grid gap-x-8 gap-y-6 md:grid-cols-2" data-id="element-298" data-mp="1ps29m05fetog">
          {tools.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex items-start gap-4" data-id="element-299" data-mp="158y0w0rqzey4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy text-white" data-id="element-300" data-mp="157mxi227s97j">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-301" data-mp="w8roki7scl0j" />
                </span>
                <div data-id="element-302" data-mp="w6yj368ws6u4">
                  <h3 className="text-[17px] font-bold leading-snug text-ink" data-id="element-303" data-mp="109v6da9e8r4e">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-snug text-muted" data-id="element-304" data-mp="1o07cqgozqfsv">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-14 rounded-3xl border border-slate-200 bg-white p-6 text-center sm:p-10" data-id="element-305" data-mp="1syilsp7goma1">
          <h3 className="font-serif text-2xl font-black leading-tight text-ink sm:text-3xl" data-id="element-306" data-mp="1eyrawxc8rm09">
            Any implant case that walks into your office…
          </h3>
          <p className="mt-3 text-[17px] text-muted" data-id="element-307" data-mp="3jukpk4bmqrb">You won't have to approach every case as if you're starting from zero.</p>
          <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-308" data-mp="8ks23uhibgrr">
            {["Evaluate it.", "Identify what matters.", "See what's unresolved.", "Accept, prepare, or refer."].map(s => <p key={s} className="rounded-xl bg-brand-light px-3 py-3 text-[15px] font-bold leading-snug text-brand-dark" data-id="element-309" data-mp="25ab77az0b81s">
                {s}
              </p>)}
          </div>
        </div>

        <SectionCta label="I want the complete system" data-id="element-310" data-mp="1whrfkuh4u3qg" />
      </div>
    </section>;
}